var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVideoCameraSlash = function SvgIconVideoCameraSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.599 1.51a1 1 0 0 1 1.412.067L16.25 15.04V6.625h-4.84a1 1 0 1 1 0-2h5.09a1.75 1.75 0 0 1 1.75 1.75v2.402l3.754-2.145A1 1 0 0 1 23.5 7.5v9a1 1 0 0 1-1.496.868l-3.754-2.145v2.016l3.49 3.838a1 1 0 1 1-1.48 1.346l-2.951-3.246a1.75 1.75 0 0 1-.809.198H2.25a1.75 1.75 0 0 1-1.75-1.75V6.375a1.75 1.75 0 0 1 1.75-1.75h1.83L2.531 2.923a1 1 0 0 1 .067-1.413m3.298 5.115H2.5v10.75h13.17zM18.25 12.92l3.25 1.857V9.223l-3.25 1.857z",
    clipRule: "evenodd"
  })));
};
export default SvgIconVideoCameraSlash;